export const INTERNAL_USER = 'internal';
export const EXTERNAL_USER = 'external';
export const ACCOUNT_AND_REGION = 'accountAndRegion';
export const SELECTED_ACCOUNT = 'selectedAccount';
export const SELECTED_REGION = 'selectedRegion';
export const DXP_FOOD_ACCGRP_PRODUCTS = 'dxp_food_accgrp_products';
export const FOOD_ONBOARDING_URL = '/food/onboarding';
export const REGIONAL_ACCOUNTS = ['A-00000CGL-NA', 'A-00000CGL-EMEA', 'A-00000CGL-LATAM', 'A-00000CGL-APAC'];
export const AUTO_OPEN_ACCOUNT_MODAL_PAGES = [
  { page: '/orderbuilder', roles: ['DXP_Food_AccGrp_Purchase_Products'] },
  { page: '/orders', roles: ['DXP_Food_AccGrp_Orders'] },
  { page: '/contracts', roles: ['DXP_Food_AccGrp_Contracts'] }
];
